import component from './component/'
import register from '@iez/core/start/init/register/'
import screenfull from 'screenfull'
import router from '@iez/core/router/'
import { noop } from 'lodash'

export default () => {
  const route = {
    path: '/fullscreen',
    name: 'Fullscreen'
  }

  register({
    pages: {
      Fullscreen: {
        ...route,
        ...component,
        render: createElement =>
          createElement(component, {
            on: {
              finish: () => {
                if (screenfull.isEnabled) {
                  screenfull.on('change', () => {
                    if (screenfull.isFullscreen) {
                      localStorage.setItem(`fullscreen`, true)
                      router.push(`/`)
                        .catch(noop)
                    }
                  })
                  screenfull.request()
                }
              }
            }
          })
      }
    }
  })
}
